const shimmer =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

const EmailMessageShimmer = () => {
  return (
    <div className="px-[12px] py-[12px] flex flex-col gap-[12px] mt-5">
      <div className="flex items-start gap-[8px]">
        <div className={`w-[26px] h-[26px] shrink-0 rounded-full ${shimmer}`} />
        <div className="flex-1 min-w-0 flex flex-col gap-[6px]">
          <div className="flex items-center gap-[8px]">
            <div className={`h-[14px] w-[120px] ${shimmer}`} />
            <div className="w-[2px] h-[2px] bg-gray-placeholder dark:bg-gray-placeholder-dk rounded-full" />
            <div className={`h-[12px] w-[80px] ${shimmer}`} />
          </div>
          <div className={`h-[12px] w-[160px] ${shimmer}`} />
        </div>
      </div>

      <div className="pl-[34px]">
        <div className="flex flex-col gap-[6px]">
          <div className={`h-[14px] w-full ${shimmer}`} />
          <div className={`h-[14px] w-[90%] ${shimmer}`} />
          <div className={`h-[14px] w-[70%] ${shimmer}`} />
        </div>
      </div>
    </div>
  );
};

export default EmailMessageShimmer;
